"use client";
import { useEffect, useRef } from "react";

export function Starfield() {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = ref.current; if (!canvas) return;
    const ctx = canvas.getContext("2d"); if (!ctx) return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let raf = 0; let stars: { x: number; y: number; r: number; a: number; tw: number; p: number; gold: boolean }[] = [];
    const DPR = Math.min(window.devicePixelRatio || 1, 2);
    function build() {
      const w = window.innerWidth, h = window.innerHeight;
      canvas!.width = w * DPR; canvas!.height = h * DPR;
      canvas!.style.width = w + "px"; canvas!.style.height = h + "px";
      const count = Math.min(160, Math.round((w * h) / 9000));
      stars = Array.from({ length: count }, () => ({
        x: Math.random() * w * DPR, y: Math.random() * h * DPR,
        r: (Math.random() * 1.1 + 0.3) * DPR, a: Math.random() * 0.5 + 0.2,
        tw: Math.random() * 0.02 + 0.004, p: Math.random() * Math.PI * 2, gold: Math.random() < 0.14,
      }));
    }
    function draw(t: number) {
      ctx!.clearRect(0, 0, canvas!.width, canvas!.height);
      for (const s of stars) {
        const a = reduce ? s.a : s.a + Math.sin(t * s.tw + s.p) * 0.22;
        ctx!.beginPath(); ctx!.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx!.fillStyle = s.gold ? `oklch(0.83 0.13 84 / ${a})` : `oklch(0.93 0.02 250 / ${a})`;
        ctx!.fill();
      }
      if (!reduce) raf = requestAnimationFrame(draw);
    }
    build(); draw(0);
    const onResize = () => { build(); if (reduce) draw(0); };
    window.addEventListener("resize", onResize);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", onResize); };
  }, []);
  return <canvas id="stars" ref={ref} aria-hidden="true" />;
}
